export default function AuthFooter() {
  return (
    <div className="mt-40 text-xs text-[#CECECE] font-public-sans text-center font-normal">
      © 2026 Supreme Edits. All rights reserved.
    </div>
  );
}